import { render, staticRenderFns } from "./marketHistoryList.vue?vue&type=template&id=1dd1bda6&scoped=true&"
import script from "./marketHistoryList.vue?vue&type=script&lang=js&"
export * from "./marketHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./marketHistoryList.vue?vue&type=style&index=0&id=1dd1bda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd1bda6",
  null
  
)

export default component.exports